import {getProductByArticle} from "@/entities/product/api/productApi";
import {useQuickViewStore} from "@/Stores/Site/Product";
import {getInitialProductData} from "@/features/quickView/lib/getInitialProductData";

export function useQuickView() {
    const openModal = useQuickViewStore(state => state.openModal);
    const closeModal = useQuickViewStore(state => state.closeModal);
    const setLoading = useQuickViewStore(state => state.setLoading);
    const setData = useQuickViewStore(state => state.setData);

    const openQuickView = async (article) => {
        try {
            setLoading(true);
            openModal();

            const response = await getProductByArticle({
                article,
                type: 'quickView',
            });
            const {success} = response.data;
            const {data, status} = success;

            if (!status) throw new Error('Не удалось получить данные');

            const product = data.product;

            const {productDataCurrent} = getInitialProductData(product);

            setData({product, productDataCurrent});
        } catch (e) {
            console.log(e);
            closeModal();
        } finally {
            setLoading(false);
        }
    };

    return {openQuickView};
}
